import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/Button';
import DataItem from 'components/DataItem';
import SectionTitle from 'components/typography/SectionTitle';
import { getPrimaryFromList } from 'shared/helpers/common';
import ContactTabEditModal from './ContactTabEditModal';

export default function ContactTab({ userData = {}, setUserData }) {
  const [primaryEmail, setPrimaryEmail] = useState({});
  const [primaryEmailIndex, setPrimaryEmailIndex] = useState(null);
  const [primaryPhone, setPrimaryPhone] = useState({});
  const [primaryPhoneIndex, setPrimaryPhoneIndex] = useState(null);
  const [isEditModalOpen, setEditModalState] = useState(false);
  const { moduleConfig = {} } = useSelector((state) => state.settings);

  useEffect(() => {
    const { phone = [] } = userData;
    const { data: phoneData, index: phoneIndex } = getPrimaryFromList(
      phone,
      {},
    );
    setPrimaryPhone(phoneData);
    setPrimaryPhoneIndex(phoneIndex);

    const { emailAddress = [] } = userData;
    const { data: emailData, index: emailIndex } = getPrimaryFromList(
      emailAddress,
      {},
    );
    setPrimaryEmail(emailData);
    setPrimaryEmailIndex(emailIndex);
  }, [userData]);

  return (
    <>
      <SectionTitle label="Contact" />
      <div className="lg:mt-[40px] bg-white rounded-t-lg">
        <div className="flex flex-wrap p-4">
          <DataItem
            isVisible={
              moduleConfig?.['Client-Client-view-contactNumber-visible']
            }
            label="Contact number"
            value={primaryPhone?.visibleNumber}
            labelClassName="mb-[20px]"
            isHalf
          />
          <DataItem
            isVisible={moduleConfig?.['Client-Client-view-email-visible']}
            label="Contact email"
            value={primaryEmail?.email}
            labelClassName="mb-[20px]"
            isHalf
          />
        </div>
      </div>
      <div className="bg-white border-t rounded-b-lg flex justify-end">
        <Button className="my-4 mx-6" onClick={() => setEditModalState(true)}>
          <div className="px-6">Edit</div>
        </Button>
      </div>
      {isEditModalOpen && (
        <ContactTabEditModal
          isOpen={isEditModalOpen}
          setModalState={setEditModalState}
          userData={userData}
          setUserData={setUserData}
          primaryEmailIndex={primaryEmailIndex}
          primaryPhoneIndex={primaryPhoneIndex}
          moduleConfig={moduleConfig}
        />
      )}
    </>
  );
}
